module.exports = __webpack_public_path__ + "img/icon-body-active.2b007131.png";